import React from 'react'
import { useTranslation } from 'react-i18next'

import MuiLink from '@mui/material/Link'

import { Log } from '../../types/log'

interface ProfileLinkProps {
  machineSlug: string
  log: Log | null
}

const ProfileLink = (props: ProfileLinkProps): JSX.Element => {
  const { t } = useTranslation()
  const profileId = props.log?.profile_data?.id || props.log?.profile_id
  const profileName = props.log?.profile_data?.name || props.log?.profile_name

  return profileId && profileName ? (
    <MuiLink href={`/machine/${props.machineSlug}/profiles/${profileId}`} target="_blank" rel="noopener noreferrer">
      {profileName}
    </MuiLink>
  ) : (
    <span>{profileName || t('logsview.unknownprofile')}</span>
  )
}

export default ProfileLink
